import { render, staticRenderFns } from "./afterQuestion.vue?vue&type=template&id=e682ca28&"
import script from "./afterQuestion.vue?vue&type=script&lang=js&"
export * from "./afterQuestion.vue?vue&type=script&lang=js&"
import style0 from "./afterQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports